const numberFormats = {
  en: {
    currency: { style: 'currency', currency: 'USD' },
  },

  sq: {
    currency: { style: 'currency', currency: 'EUR', currencyDisplay: 'code' },
  },
};

export default numberFormats;
